import React, { Component } from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { Container, Button, Col, Row, ListGroup, ListGroupItem, CustomInput, Collapse } from 'reactstrap';
import QuellenModal from '../modals/QuellenModal';
import Signup from '../modals/Signup'
import SignupOrganisation from '../modals/SignupOrganisation'

import { CheckFilter, RangeFilter } from '../ui-elements/Filter';

import InputRange from 'react-input-range';

import texts from '../../data/texts';
import quellen from '../../data/quellen';



class Mockup extends Component {
  render(){

    const style = {
      container: {
        width: '100%',
        position: 'relative',
      },
      laptop: {
        width: '100%',
        height: 'auto',
      },
      screen_container: {
        width: '73.4%',
        height: '74.458%',
        position: 'absolute',
        top: '6.385%',
        left: '13.333%',
        overflow: 'hidden'
      },
      screen: {
        width: '100%',
        height: 'auto',
        animation: 'scroll 10s ease-in-out infinite'
      },
      bar: {
        width: '100%',
        height: 'auto',
        position: 'absolute',
        top: 0,
        left: 0,
        boxShadow: '0px 0px 4px 0px rgba(81,81,81,0.25)',
        animation: 'moveIn 10s ease-in-out infinite'
      }
    }

    return (
      <div style={{width: '150%', transform: 'translate(-10%, 9.5%)', zIndex: -3}}>
        <div style={style.container}>
          <img src="/imgs/paul_mockup_laptop.png" style={style.laptop}/>
          <div style={style.screen_container}>
            <img src="/imgs/paul_mockup_scrollable_page.png" style={style.screen} />
            <img id="fixedBar" src="/imgs/paul_mockup_fixed_bar.png" style={style.bar} />
            <div style={{ position:'absolute', top:0, left:0, bottom:0, right:0, boxShadow: 'inset 0px 0px 6px 0px rgba(81,81,81,0.25)' }}></div>
          </div>
        </div>
      </div>
    );
  }
}



class Landing extends Component {

  constructor(props){
    super(props);
    this.state = {
      quellen: false,
    };
  }
  showQuellen = () => {
    this.setState({
      quellen: true
    });
  }
  toggleQuellen = () => {
    this.setState({
      quellen: !this.state.quellen
    });
  }

  render() {
    return (
      <div className='d-flex flex-column justify-content-center' style={{flex: 1}}>
        <Container>

          <Row className='headerSection justify-content-start pt-2 pt-sm-5' style={{
            position: 'relative',
            backgroundImage: 'url(/imgs/divider_shadow.png)',
            backgroundSize: '100% auto',
            backgroundPosition: 'center bottom',
            backgroundRepeat: 'no-repeat'
          }}>
            <Col xs="12" md="6" className='align-self-center pt-2 pt-md-5'>
              <h4>
                paul&nbsp;<span className="font-weight-normal">open search</span>
              </h4>
              <h1>{ texts.product_definition }</h1>
              <Signup className="mt-4 mb-0 mb-md-5 d-block d-md-inline-block shadow" />
            </Col>
            <Col xs="12" md="6" className='align-self-end'>
              <Mockup />
            </Col>
          </Row>


          <Row className='justify-content-center py-5 text-left' style={{ position: 'relative' }}>
            <Col xs="12" md="5" className="align-self-center text-center order-1 order-md-0">
              <div className="mr-0 mr-md-5" style={{position: 'relative'}}>
                <ListGroup id="quellenListe" className="shadow">
                  { quellen.map(quelle => <ListGroupItem className="text-left font-weight-bold border-0" style={{ marginBottom: 1 }}>
                    <i className="fas fa-archive mr-3 text-secondary"></i>{ quelle.name }
                  </ListGroupItem>) }
                  <ListGroupItem tag="a" onClick={this.showQuellen} className="bg-secondary text-white text-left border-0">
                    <i className="fas fa-database mr-3 text-white"></i>Auswahl anzeigen
                  </ListGroupItem>
                </ListGroup>
                <div className="text-center" style={{ transform: 'translateY(-15px)' }}>
                  <img src="/imgs/paul_logo_color_small.svg" style={{width: 60, height: 'auto'}} className="mt-4" />
                </div>
              </div>
            </Col>
            <Col xs="12" md="5" className="align-self-center order-0 order-md-1 text-center text-md-left">
              <h4>{texts.section_1.headline}</h4>
              <p>{texts.section_1.text}</p>
              <Button color="secondary" className="mb-5" outline onClick={this.showQuellen}>{texts.section_1.button}</Button>
            </Col>
          </Row>

          <Row className="text-center border-top pt-3">
            <Col>
              <small>{texts.section_1.partner}</small>
            </Col>
          </Row>
          <Row className='justify-content-center text-center pt-4 pb-5' style={{
            position: 'relative',
            backgroundImage: 'url(/imgs/divider_shadow.png)',
            backgroundSize: '100% auto',
            backgroundPosition: 'center bottom',
            backgroundRepeat: 'no-repeat'
          }}>
            <Col xs="12" className="align-self-center px-5">
              <img src="/imgs/medienpartner/logo_100x80_lemond.png" className="img-fluid mx-2 mx-md-3" style={{maxWidth: 100, height: 'auto', width: '25%'}}/>
              <img src="/imgs/medienpartner/logo_100x80_blaetter.png" className="img-fluid mx-2 mx-md-3" style={{maxWidth: 100, height: 'auto', width: '25%'}}/>
              <img src="/imgs/medienpartner/logo_100x80_agora.png" className="img-fluid mx-2 mx-md-3" style={{maxWidth: 100, height: 'auto', width: '25%'}}/>
            </Col>
          </Row>
          <QuellenModal toggle={this.toggleQuellen} isOpen={this.state.quellen} />


          <Row className='justify-content-center py-5 text-center text-md-left' style={{ position: 'relative' }}>
            <Col xs="12" md="5" className="align-self-center">
              <h4>{texts.section_2.headline}</h4>
              <p className="mb-5">{texts.section_2.text}</p>
            </Col>
            <Col xs="12" md="5" className="align-self-center text-center">
              <div className="ml-0 ml-md-5" style={{position: 'relative'}}>
                <ListGroup className="filterList">
                  <RangeFilter name="Jahr" min={1950} max={2018} />
                  <CheckFilter name="Publikations-Typ" items={texts.PublikationsTypen}/>
                  <RangeFilter name="Seitenzahl" min={5} max={125} />
                  <CheckFilter name="Sprachen" items={texts.Sprachen} isOpen={true}/>
                </ListGroup>

              </div>
            </Col>

          </Row>


        </Container>

        <Container fluid className="bg-secondary">

          <Container>
            <Row className='justify-content-center py-5'>
              <Col xs="12" lg="8" className='text-center pt-5'>
                <img src="/imgs/paul_logo_color_small.svg" style={{width: '80px', height: 'auto'}} className="mb-4" />
                <h2 className="text-white mb-3" dangerouslySetInnerHTML={{__html: texts.section_cta.headline.join('<br />')}}></h2>
                <p className="text-white font-weight-bold mb-3">{texts.section_cta.subline}</p>
                <div className="text-right">
                  <Signup className="my-4 shadow-sm" />
                </div>
                <ListGroup flush className="text-left">
                  { texts.arguments.map(argument =>
                    <ListGroupItem
                      key={argument}
                      style={{ borderColor: 'rgba(255, 255, 255, .25)' }}
                      className="d-flex justify-content-between align-items-center bg-transparent text-white font-weight-bold"
                    >
                      <span>{ argument }</span>
                      <i className="fas fa-check mx-2 mx-md-4"></i>
                    </ListGroupItem>
                  ) }
                </ListGroup>
                <small className="text-white d-block mt-5" dangerouslySetInnerHTML={{__html: texts.small_text.join('<br />')}}></small>
              </Col>
            </Row>
          </Container>

        </Container>
        <Container fluid className="bg-secondary-dark">

          <Container>
            <Row className='justify-content-center'>
              <Col xs="12" lg="8" className='text-center py-5'>
                <h3 className="text-white font-weight-bold mb-2">{texts.orga_cta_headline}</h3>
                <p className="text-white font-weight-bold mb-4">{texts.orga_cta_subline}</p>
                <SignupOrganisation />
              </Col>
            </Row>
          </Container>

        </Container>

      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;

export default compose(
  withRouter
)(Landing);



// WEBPACK FOOTER //
// ./src/components/pages/Landing.js